import type { IMembershipRepository } from '../repositories/IMembershipRepository.js';
import type { InvitationEntity } from '../entities/MembershipEntity.js';

interface Deps { membershipRepository: IMembershipRepository; }
export function createListInvitationsUseCase({ membershipRepository }: Deps) {
  return async function listInvitations(orgId: string, projectId?: string): Promise<InvitationEntity[]> {
    return membershipRepository.listInvitations(orgId, projectId);
  };
}
